export default "__VITE_ASSET__BZyuUsf4__"